import { createTheme } from '@mui/material';

let theme = createTheme({
	components: {
		MuiSnackbar: {
			styleOverrides: {
				root: {
					width: '1200px',
				},
			},
		},
		MuiButton: {
			variants: [
				{
					props: { variant: 'contrast' },
					style: {
						color: '#000',
						borderColor: '#000',
						':hover': {
							backgroundColor: 'rgba(87, 141, 64, 0.9)',
						},
					},
				},
			],
		},
	},
	typography: {
		// Non standard headings - to be brought in line for the design system
		'dashboard-card-heading': {
			fontSize: 24,
			fontWeight: 400,
			lineHeight: '32px',
			color: '#578d40',
		},
	},
	palette: {
		primary: {
			light: '#ffb72e',
			main: '#f68a20',
			dark: '#da7009',
		},
		secondary: {
			light: '#6ba03e',
			main: '#578d40',
			dark: '#365a27',
		},
		navigationButtonColor: {
			main: '#f68a20',
		},
		regNumberColor: {
			main: '#f68a20',
		},
		annualMileageFont: {
			main: '#000',
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
		background: {
			default: '#f9f9f9',
		},
		icon: {
			main: '#f68a20',
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					'dashboard-card-heading': 'h2',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 0,
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					background:
						'linear-gradient(63deg, rgba(255,255,255,1) 75%, rgba(247,209,160,1) 75%, rgba(247,209,160,1) 76%, rgba(244,182,86,1) 76%, rgba(247,188,108,1) 77%, rgba(255,180,45,1) 77%, rgba(246,139,31,1) 77%, rgba(246,139,31,1) 83%, rgba(246,170,31,1) 90%, rgba(246,170,31,1) 94%);',
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderColor: theme.palette.common.black,
				},
				notchedOutline: {
					borderColor: theme.palette.common.black,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: ({ ownerState }: { ownerState: { color: string; variant: string; id: string } }) => ({
					...(ownerState.variant !== 'text' &&
						ownerState.variant !== 'outlined' && {
							color: theme.palette.common.white,
						}),
					...(ownerState.variant !== 'text' && {
						...(ownerState.color === 'secondary' && {
							borderColor: theme.palette.secondary.main,
							':hover': {
								backgroundColor: 'rgba(87, 141, 64, 0.9)',
							},
						}),
						...(ownerState.color === 'primary' && {
							borderColor: theme.palette.primary.main,
							':hover': {
								backgroundColor: 'rgba(246, 138, 32, 0.9)',
							},
						}),
					}),
				}),
			},
			variants: [
				{
					props: { variant: 'link' },
					style: {
						...theme.typography.body1,
						color: theme.palette.primary.main,
						textDecoration: 'underline',
						padding: 0,
						background: 'transparent',
						'&:hover': {
							color: theme.palette.primary.light,
							background: 'transparent',
							textDecoration: 'underline',
						},
						'&:visited': {
							background: 'transparent',
							color: theme.palette.primary.main,
							'&:hover': {
								color: theme.palette.primary.light,
							},
						},
					},
				},
			],
		},

		MuiToggleButton: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
					borderColor: theme.palette.common.black,
					'&.Mui-selected': {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.common.white,
						'&:hover': {
							backgroundColor: theme.palette.primary.main,
						},
					},
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: `
        body, html, #root {
          height: 100%;
        }
        html {
          overflow-y: scroll;
        }
        /* ===== Scrollbar CSS ===== */
        /* Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${theme.palette.grey[500]} ${theme.palette.background.default};
        }

        /* Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
          width: 12px;
        }

        *::-webkit-scrollbar-track {
          background: ${theme.palette.background.default};
        }

        *::-webkit-scrollbar-thumb {
          background-color: ${theme.palette.grey[500]};
          border-radius: 10px;
          border: 3px solid ${theme.palette.background.default};
        }`,
		},
	},
});

const themeExport = theme;
export default themeExport;
